export default "__VITE_ASSET__a36843e7__"